module.exports = __webpack_public_path__ + "img/100saludable.1dd28c31.png";